import React from "react";
import { useNavigate } from "react-router-dom";
import { Error } from "components/error";
import i18n from "../../i18n";
import { language } from "index";
import { runBasedOnCoutries } from "../../util";

export const ErrorPage = () => {
  const navigate = useNavigate();
  const countryCode = ["id", "en"]
  const handleClick = () => {
    if (runBasedOnCoutries(["id", "en"])) {
      navigate("/reason-delete");
    } else {
      navigate("/*");
    }
  };

  return (
    <>
      <Error
         imagePath={countryCode?.includes(language as string) ? '/mascot_generic_error.svg': '/error.svg'} 
        header={i18n.t("SomethingWentWrong")}
        subheader={
          <React.Fragment>
            {i18n.t("UnableToRemove")}
            <br />
            {i18n.t("PleaseTryItAgain")}
          </React.Fragment>
        }
        btnAction={i18n.t("TryItAgain")}
        handleReload={handleClick}
      />
    </>
  );
};
